import React, { useRef, useState } from 'react';

import i18n from 'i18next';
import Share from '@mui/icons-material/Share';

import { Button } from 'uikit/buttons';
import { useOnClickOutside } from 'uikit/utils';

import getSocialShareOptions from '../helpers/getSocialShareOptions';

import useIsMyLearningEnabled from '../hooks/useIsMyLearningEnabled';

import styles from '../styles/socialShare.module.scss';

const SocialShareLink = ({ ariaLabel, url, onClick, icon }) => (
  <li>
    <Button
      ariaLabel={ariaLabel}
      icon={icon}
      isExternalLink
      onClick={onClick}
      rel="noreferrer"
      role="menuitem"
      size="xsmall"
      target="_blank"
      to={url}
    />
  </li>
);

const SocialShare = ({ buttonClassName, pageTitle }) => {
  const [isOpen, setIsOpen] = useState(false);

  const isMyLearningEnabled = useIsMyLearningEnabled();

  const containerRef = useRef();

  const socialOptions = getSocialShareOptions(pageTitle);

  useOnClickOutside({ ref: containerRef, callback: () => setIsOpen(false) });

  return (
    <div ref={containerRef}>
      <Button
        className={buttonClassName}
        icon={<Share sx={{ height: 18, width: 18}} />}
        onClick={() => setIsOpen(!isOpen)} 
        text={isMyLearningEnabled ? null : i18n.t('share')}
        variant={isMyLearningEnabled ? "ghost" : "link"}
        size="xsmall"
      />
      {isOpen && (
        <ul role="menu" className={styles.socialOptionsContainer}>
          {socialOptions.map(({ ariaLabel, icon, url, onClick }) => (
            <SocialShareLink
              ariaLabel={ariaLabel}
              key={url}
              icon={icon}
              url={url}
              onClick={onClick}
            />
          ))}
        </ul>
      )}
    </div>
  );
};

export default React.memo(SocialShare);
